export const API_URL = 'https://api.garionix.com/';
// export const API_URL = "http://geneseaction-lb-dev-927126529.us-west-2.elb.amazonaws.com/"
